import { Seo } from '../components/Seo';

const Terms = () => (
  <>
    <Seo
      title="Terms · Prepzio"
      description="The terms under which you can use the Prepzio marketing site and join the private beta waitlist."
      path="/terms"
    />
    <main className="section">
      <div className="container-narrow legal">
        <p className="eyebrow">Terms</p>
        <h1>Terms of use</h1>
        <p className="legal__date">Last updated · June 2026</p>

        <p>
          These short terms govern your use of the Prepzio marketing site and the waitlist. Once the
          private beta opens, a separate set of in-app terms will apply and you will be asked to
          accept them at sign-in.
        </p>

        <h2>1. Who we are</h2>
        <p>
          &ldquo;Prepzio&rdquo; refers to the team building the Prepzio mobile application and this
          marketing site. We can be reached at{' '}
          <a href="mailto:hello@prepzio.io">hello@prepzio.io</a>.
        </p>

        <h2>2. What we offer here</h2>
        <p>
          This site is informational and lets you join the waitlist. Nothing on this page is a
          binding offer to provide a product on a particular date.
        </p>

        <h2>3. Acceptable use</h2>
        <ul>
          <li>Do not submit emails that are not yours.</li>
          <li>Do not attempt to disrupt the service.</li>
          <li>
            Do not upload or attempt to upload confidential interview material once the app
            launches; see the FAQ on the home page.
          </li>
        </ul>

        <h2>4. Intellectual property</h2>
        <p>
          Prepzio, the brand, copy, and visual design are © Prepzio. The underlying software is
          private to Prepzio. You may share screenshots for personal commentary or reviews.
        </p>

        <h2>5. Disclaimer</h2>
        <p>
          During the private beta, Prepzio is provided &ldquo;as is&rdquo;. The product is intended
          as a learning tool and is explicitly not a substitute for real-world experience or an
          interview cheat tool.
        </p>

        <h2>6. Governing law</h2>
        <p>
          Until incorporation details are finalised these terms are governed by the laws of the
          country where the founding team operates. Disputes are resolved in good faith first.
        </p>

        <h2>7. Changes</h2>
        <p>We may revise these terms. The date at the top reflects the last change.</p>
      </div>
    </main>
  </>
);

export default Terms;
